// extracted by mini-css-extract-plugin
export default {"container":"container-RTBXKi7G","link":"link-OEVzL25S"};